"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallIdCustomArchitecture = getInstallIdCustomArchitecture;
exports.getInstallFromContext = getInstallFromContext;
exports.isRuntimeInstallId = isRuntimeInstallId;
exports.isGlobalLegacyInstallId = isGlobalLegacyInstallId;
exports.getArchFromLegacyInstallId = getArchFromLegacyInstallId;
exports.getVersionFromLegacyInstallId = getVersionFromLegacyInstallId;
exports.getAssumedInstallInfo = getAssumedInstallInfo;
const DotnetCoreAcquisitionWorker_1 = require("../Acquisition/DotnetCoreAcquisitionWorker");
const DotnetInstall_1 = require("../Acquisition/DotnetInstall");
const DotnetInstallMode_1 = require("../Acquisition/DotnetInstallMode");
function getInstallIdCustomArchitecture(version, architecture, mode, installType = 'local') {
    if (architecture === null || architecture === 'null') {
        // Use the legacy method (no architecture) of installs
        return installType === 'global' ? `${version}-global` : version;
    }
    else if (architecture === undefined) {
        architecture = DotnetCoreAcquisitionWorker_1.DotnetCoreAcquisitionWorker.defaultArchitecture();
    }
    return installType === 'global' ? `${version}-global~${architecture}${mode === 'aspnetcore' ? '~aspnetcore' : ''}` :
        `${version}~${architecture}${mode === 'aspnetcore' ? '~aspnetcore' : ''}`;
}
function getInstallFromContext(ctx) {
    const acquireContext = ctx.acquisitionContext;
    return {
        installId: getInstallIdCustomArchitecture(acquireContext.version, acquireContext.architecture, ctx.acquisitionContext.mode, acquireContext.installType),
        version: acquireContext.version,
        architecture: acquireContext.architecture,
        isGlobal: acquireContext.installType ? acquireContext.installType === 'global' : false,
        installMode: ctx.acquisitionContext.mode
    };
}
function isRuntimeInstallId(installId) {
    const installIdVersion = getVersionFromLegacyInstallId(installId);
    return !(DotnetInstallMode_1.DOTNET_INSTALL_MODE_LIST.filter((x) => x !== 'runtime')).some((mode) => installId.includes(mode))
        && (0, DotnetInstall_1.looksLikeRuntimeVersion)(installIdVersion);
}
function isGlobalLegacyInstallId(installId) {
    return installId.toLowerCase().includes('global');
}
function getArchFromLegacyInstallId(installId) {
    var _a;
    const splitId = installId.split('~');
    if (((_a = splitId === null || splitId === void 0 ? void 0 : splitId.length) !== null && _a !== void 0 ? _a : 0) >= 2) {
        return splitId[1];
    }
    return undefined;
}
function getVersionFromLegacyInstallId(installId) {
    if (isGlobalLegacyInstallId(installId)) {
        const splitId = installId.split('-');
        return splitId[0];
    }
    else if (installId.includes('~')) {
        const splitId = installId.split('~');
        return splitId[0];
    }
    else // legacy, legacy install id (before it included the arch)
     {
        return installId;
    }
}
/**
 * @deprecated This function is for legacy install ids only. Do not use for new code.
 */
function getAssumedInstallInfo(id, mode) {
    var _a;
    return {
        installId: id,
        version: getVersionFromLegacyInstallId(id),
        architecture: (_a = getArchFromLegacyInstallId(id)) !== null && _a !== void 0 ? _a : DotnetCoreAcquisitionWorker_1.DotnetCoreAcquisitionWorker.defaultArchitecture(),
        isGlobal: isGlobalLegacyInstallId(id),
        // This code is for legacy install strings where the info was not recorded.
        // At the time only runtime or sdk was permitted and there were no outlier edge case versions that would be wrong.
        // So this assumption can hold true below. Do not utilize this going forward for new code.
        installMode: (mode !== null && mode !== void 0 ? mode : isRuntimeInstallId(id)) ? 'runtime' : 'sdk'
    };
}
//# sourceMappingURL=InstallIdUtilities.js.map